import { useSelector } from 'react-redux';
import styles from './Cart.module.scss';
import { getCartItems, getTotalPrice } from '../../../redux/CartSlice';
import CartItem from '../CartItem/CartItem';
import { Text } from '../../../shared/ui/Text/Text';
import { Stack } from '../../../shared/ui/Stack/Stack';
import { downloadIcon } from '../../../shared/assets/svg/downloadIcon';
import { useRef } from 'react';
import html2canvas from 'html2canvas';


const Cart = () => {
   const cartRef = useRef();
   const saveCartAsImage = () => {
    if(cartRef.current) {
        html2canvas(cartRef.current).then(canvas => {
            const dataUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a')
            link.href = dataUrl;
            link.download = 'план лечения.png';
            link.click();
        })
    }
   }

   const cartItems = useSelector(getCartItems);
   const totalPrice = useSelector(getTotalPrice)
    return (
        <section className={styles.container}>
        <div ref={cartRef} className={styles.cart}>
            <div       
                className={styles.content}>           
                    <Text type="h2" size='l' className={styles.title}>Услуга</Text>             
                    <Text type="h2" size='l' className={styles.title}>Кол-во</Text>
                    <Text type="h2" size='l' className={styles.title}>Сумма</Text>
                    <Text type="h2" size='l' className={styles.title}></Text>
            </div>
                <hr/>
            <div>
                {cartItems.map(cartItem => <CartItem key={cartItem.id} cartItem = {cartItem}/>)}
            </div> 
            <Stack 
                justifyContent = 'justifyBetween'
                alignItems='alignCenter'        
                className={styles.total__content}>     
                    <Text  type="h2" size='l'  className={styles.total}>ИТОГО:</Text>
                    <Text  type="h2" size='l'  className={styles.total}>{totalPrice} руб.</Text>
            </Stack>
            <hr/>  
            <Stack
                justifyContent = 'justifyEnd'
            >
                <button onClick={saveCartAsImage}  className={styles.btn}>{downloadIcon()}</button>
            </Stack>
               
        </div>
        </section>
    )
}

export default Cart;